import React from 'react';
import IconButton from '@mui/material/IconButton';
import { getResponsiveSize } from '../../../utils';
import { classNames } from '../../../utils/classNames';

export const fingerBtnHeght = 100;

export interface PhaserActionButtonProps {
  icon: React.ReactElement;
  onClick: () => void;
  backgroundColor?: string;
  size: 'small' | 'medium' | 'large';
  style: React.CSSProperties;
  width: number;
  rotateDeg: number;
  isRightGroup: boolean;
  className?: string;
  isDisabled: boolean;
}

const PhaserActionButton: React.FC<PhaserActionButtonProps> = ({
  icon,
  onClick,
  backgroundColor,
  size = 'large',
  style,
  width = 360,
  rotateDeg = 0,
  isRightGroup = true,
  isDisabled,
  className = '',
}) => {
  return (
    <IconButton
      className={classNames('', {}, [className])}
      onClick={onClick}
      size={size}
      style={style}
      disabled={isDisabled}
      disableRipple
      sx={{
        backgroundColor,
        width: getResponsiveSize(width),
        height: getResponsiveSize(fingerBtnHeght),
        borderRadius: 28,
        transform: `rotate(${rotateDeg}deg)`,
        justifyContent: isRightGroup ? 'flex-start' : 'flex-end',
        '&.MuiButtonBase-root:active': {
          opacity: 1,
        },
        '& svg': {
          color: '#FFF',
          opacity: 1,
          zIndex: 2,
          transform: `rotate(${-rotateDeg}deg)`,
        },
        '&:hover': {
          backgroundColor,
        },
        '&.Mui-disabled': {
          backgroundColor,
        },
      }}
    >
      {icon}
    </IconButton>
  );
};

export default PhaserActionButton;
